import { get } from '@/api/client'
import type { CustomOAuthProvider } from '@/types'

export async function getOAuthState(): Promise<string> {
  const data = await get<string | { state?: string }>('/api/oauth/state')
  if (typeof data === 'string') return data
  return data?.state || ''
}

function redirectTo(url: string) {
  window.location.href = url
}

export async function bindGitHubOAuth(clientId: string): Promise<void> {
  const state = await getOAuthState()
  if (!state) throw new Error('无法获取 OAuth state')
  redirectTo(
    `https://github.com/login/oauth/authorize?client_id=${clientId}&state=${state}&scope=user:email`
  )
}

export async function bindDiscordOAuth(clientId: string): Promise<void> {
  const state = await getOAuthState()
  if (!state) throw new Error('无法获取 OAuth state')
  const redirectUri = `${window.location.origin}/oauth/discord`
  redirectTo(
    `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=identify+openid&state=${state}`
  )
}

export async function bindLinuxDoOAuth(clientId: string): Promise<void> {
  const state = await getOAuthState()
  if (!state) throw new Error('无法获取 OAuth state')
  redirectTo(
    `https://connect.linux.do/oauth2/authorize?response_type=code&client_id=${clientId}&state=${state}`
  )
}

export async function bindOidcOAuth(authUrl: string, clientId: string): Promise<void> {
  const state = await getOAuthState()
  if (!state) throw new Error('无法获取 OAuth state')
  const url = new URL(authUrl)
  url.searchParams.set('client_id', clientId)
  url.searchParams.set('redirect_uri', `${window.location.origin}/oauth/oidc`)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('scope', 'openid profile email')
  url.searchParams.set('state', state)
  redirectTo(url.toString())
}

export async function bindCustomOAuth(provider: CustomOAuthProvider): Promise<void> {
  const state = await getOAuthState()
  if (!state) throw new Error('无法获取 OAuth state')
  const endpoint = provider.authorization_endpoint
  if (!endpoint?.startsWith('http://') && !endpoint?.startsWith('https://')) {
    throw new Error('OAuth 配置错误：授权端点必须是完整的 URL')
  }
  const url = new URL(endpoint)
  url.searchParams.set('client_id', provider.client_id || '')
  url.searchParams.set('redirect_uri', `${window.location.origin}/oauth/${provider.slug}`)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('scope', provider.scopes || 'openid profile email')
  url.searchParams.set('state', state)
  redirectTo(url.toString())
}
